import CircularProgress from '@mui/material/CircularProgress';
import { match } from 'ts-pattern';
import FlexRow from 'components/flex/FlexRow';
import React, { CSSProperties } from 'react';
import C from './LoaderMessage.css';

export default function LoaderMessage(p: {
  isLoading?: boolean;
  message?: string;
  style?: CSSProperties;
  mode?: 'prominent' | 'subtle';
}) {
  const progressSize = match(p.mode)
    .with('subtle', () => '1rem')
    .otherwise(() => undefined);
  const messageClass = match(p.mode)
    .with('prominent', undefined, () => C.primaryHeader)
    .with('subtle', () => C.helpContent)
    .exhaustive();
  return (
    <FlexRow style={p.style}>
      <>
        {p.isLoading !== false ? (
          <CircularProgress size={progressSize} />
        ) : null}
        {p.message && (
          <div className={messageClass} style={{ marginLeft: '0.5rem' }}>
            {p.message}
          </div>
        )}
      </>
    </FlexRow>
  );
}
